import  { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllUser, deleteUserFetch } from "../../features/action/fetchAuth";
import { UpdateUser } from "./UpdateUser";
import { renderImage } from "../../util/main";
import { FaPencil } from "react-icons/fa6";
import { FaTrash } from "react-icons/fa6";

const Admin = () => {
  const { users } = useSelector((state) => state.authFile);
  const [updateUsers, setUpdateUsers] = useState(false);
  const [userId, setUserId] = useState(false);
  const dispatch = useDispatch();

    const handleUpdate = (id) => {
      setUserId(id);
      setUpdateUsers(true);
    };

    const handleDelete = (id) => {
      if(window.confirm("Are you sure you want to delete this user?")){
        dispatch(deleteUserFetch(id))
      }
    };

  useEffect(() => {
    dispatch(getAllUser());
  }, [dispatch]);
  return (
      <div className="flex flex-col  mx-auto">
         <div className="flex flex-row  w-full m-4 text-center text-[#9E9E9E] text-base py-2 ">
            <div className="h-[5px] w-[10%] content-center">icon</div>
            <div className="h-[5px] w-[10%] content-center">login</div>
            <div className="h-[5px] w-[10%] content-center">rols</div>
            <div className="h-[5px] w-[20%] content-center">full name</div>
            <div className="h-[5px] w-[30%] content-center ">email</div>
            <div className="h-[5px] w-[10%] content-center ">change</div>
            <div className="h-[5px] w-[10%] content-center ">delete</div>
          </div>
        {users &&
          users.map((user, key) => (
           <div key={key} className="flex flex-row h-[64px] mb-1 text-center rounded-[10px] bg-white border-solid border-[1px] border-[#dbdbdb]">
            <div className="flex h-[100%] w-[10%]  content-center items-center  justify-center rounded-l-[10px] bg-[#F4F4F4]">
           { renderImage(user.fullname)}
           </div>
              <div className="flex h-[100%] w-[10%]  content-center items-center  justify-center bg-[#F4F4F4]">
                {user.username}
              </div>
              <div className="flex h-[100%] w-[10%]  content-center items-center  justify-center bg-[#F4F4F4]"
                onClick={() => handleUpdate(user)}
              >
                {user.rool}
              </div>
               <div className="flex h-[100%] w-[20%]  content-center items-center  justify-center bg-[#F4F4F4]">
                {user.fullname} 
              </div>
              <div className="flex h-[100%] w-[30%]  content-center items-center  justify-center bg-[#F4F4F4]">
                {user.email} 
              </div>
              <div className="flex h-[100%] w-[10%]  content-center items-center  justify-center bg-[#F4F4F4]">
                <button className="text-xl" onClick={() => handleUpdate(user)}>
                  <FaPencil />
                </button>
              </div>
              <div className="flex h-[100%] w-[10%]  content-center items-center  justify-center bg-[#F4F4F4]">
                <button className="text-xl" onClick={() => handleDelete(user._id)}>
                  <FaTrash />
                </button>
              </div>
             
            </div>
          ))}
         
  { updateUsers &&<UpdateUser setUpdateUsers={setUpdateUsers} item={userId} />}
      </div>
  );
};
export default Admin;